'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'puzzle';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e443';
var svgPathData = ['M32 96l0 176 48 0 0-16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 16 32 0 0-176-176 0zm0 208l0 176 176 0 0-48-16 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l16 0 0-32-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-80 0zm144 80c0 8.8 7.2 16 16 16l48 0 0 80 176 0 0-176-48 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16-32 0 0 64-48 0c-8.8 0-16 7.2-16 16zM320 32l0 24 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0 24 64 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 64 0 0-144-160 0z', 'M304 0l-16 0 0 88 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 88 64 0c0 26.5 21.5 48 48 48s48-21.5 48-48l64 0 0-208-208 0zm32 152c26.5 0 48-21.5 48-48s-21.5-48-48-48l-16 0 0-24 160 0 0 144-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0-24 16 0zM16 64l-16 0 0 448 448 0 0-240-112 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0-208-224 0zM272 320c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16 48 0 0 176-176 0 0-80-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64 32 0 0 16zM208 432l0 48-176 0 0-176 80 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0 32-16 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l16 0zM80 272l-48 0 0-176 176 0 0 176-32 0 0-16c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPuzzle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;